export default __webpack_public_path__ + "static/media/list_main_4_2.c8ae7364.png";